module.exports = __webpack_public_path__ + "img/add-photo-first-icon-male.eb74fb66.svg";